import React, { useState } from "react";
import layoutContext, { searchableMenuType } from "./index";
import { contextChildrenType, sidebarMenuType } from "Types/LayoutDataType";
import { useUserData } from "helper/UserData";

const LayoutProvider = ({ children }: contextChildrenType & {}) => {
  const [searchIcon, setSearchIcon] = useState(false);
  const [bookMarkClass, setBookMarkClass] = useState(false);
  const [pinedMenu, setPinedMenu] = useState<string[]>([""]);
  const [sideBarToggle, setSideBarToggle] = useState(false);
  const [searchableMenu, setSearchableMenu] = useState([])
  const [bookmarkList, setBookmarkList] = useState<searchableMenuType[]>([]);
  const { userApps, isLoading, userData } = useUserData();
  const effectiveMenuList = isLoading ? [] : userData == null ? [] : userData.listMenu;

  return (
    <layoutContext.Provider value={{
      bookmarkList, setBookmarkList,
      searchIcon, setSearchIcon,
      bookMarkClass, setBookMarkClass,
      pinedMenu, setPinedMenu,
      sideBarToggle, setSideBarToggle,
      searchableMenu, setSearchableMenu,
      menuList: effectiveMenuList,
    }}>
      {children}
    </layoutContext.Provider>
  );
};

export default LayoutProvider;
